import React from 'react';

const SharedInput = ({ label, type = 'text', value, onChange, placeholder, className = '' }) => {
  return (
    <div className="mb-4">
      {label && <label className="block text-black text-sm font-bold mb-2">{label}</label>}
      <input
        type={type}
        value={value}
        onChange={onChange}
        placeholder={placeholder}
        className={`w-full px-4 py-2 bg-gray-100 text-black border border-gray-300 rounded-lg shadow-sm focus:outline-none focus:ring-2 focus:ring-[#961914] transition-all duration-200 ${className}`}
      />
    </div>
  );
};

export default SharedInput;